module.exports = __webpack_public_path__ + "static/CA_CASS_Infographic_V3.4-ce13c1a7d25c63247d05447f6ceb9518.pdf";